import React, { useEffect } from "react";
import "./App.css";
import './i18n'; // Import i18n configuration
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import MobileStickyBar from "./components/MobileStickyBar";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import LICPlans from "./pages/LICPlans";
import InsurancePlans from "./pages/InsurancePlans";
import ChildInsurancePlans from "./pages/ChildInsurancePlans";
import PensionRetirementPlans from "./pages/PensionRetirementPlans";
import HealthInsuranceHub from "./pages/HealthInsuranceHub";
import NRIInsurance from "./pages/NRIInsurance";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import NRIInsuranceLeadBlog from "./pages/NRIInsuranceLeadBlog";
import PlanDetail from "./pages/PlanDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NRICalculator from "./pages/NRICalculator";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Disclaimer from "./pages/Disclaimer";
import NotFound from "./pages/NotFound";
import { initGA, trackPageView } from "./services/analytics";

// Page tracker component for SPA route changes
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <div className="App dark:bg-slate-950 min-h-screen flex flex-col justify-between">
        <BrowserRouter>
          <ScrollToTop />
          <PageViewTracker />
          <Header />
          <main className="flex-grow">
            <Routes>
              {/* Primary Public SEO Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />

              {/* Category Hubs */}
              <Route path="/lic-plans" element={<LICPlans />} />
              <Route path="/insurance-plans" element={<InsurancePlans />} />
              <Route path="/child-insurance-plans" element={<ChildInsurancePlans />} />
              <Route path="/pension-retirement-plans" element={<PensionRetirementPlans />} />
              <Route path="/health-insurance" element={<HealthInsuranceHub />} />
              <Route path="/nri-insurance" element={<NRIInsurance />} />
              <Route path="/nri-calculator" element={<NRICalculator />} />

              {/* Dynamic Policy Detail Pages */}
              <Route path="/plan/:id" element={<PlanDetail />} />

              {/* Blog & Educational Guides */}
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/best-insurance-for-nris-and-parents" element={<NRIInsuranceLeadBlog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />

              {/* Mandatory Legal & Regulatory Disclosures */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/disclaimer" element={<Disclaimer />} />

              {/* 404 Not Found Catch-All */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <MobileStickyBar />
          <Chatbot />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
